import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

export default function HomeTrusted() {
  return (
    <>
      <section className="trusted-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-9">
              <div className="center-heading">
                <h3 className="heading">Trusted by Leading Brands</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Tabs>
                <TabList>
                  <Tab>Hotels</Tab>
                  <Tab>Hospitals</Tab>
                  <Tab>Institutions</Tab>
                </TabList>

                <TabPanel>
                  <div className="trusted-content">
                    <div className="trusted-inner-sec">

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos3.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos1.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos2.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos12.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos11.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos7.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos6.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos9.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>




                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos4.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>




                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos8.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos5.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>


                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/home-brand-logos10.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>



                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="trusted-content">
                    <div className="trusted-inner-sec">


                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/hospital-logos6.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>


                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/hospital-logos2.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>


                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/hospital-logos5.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/hospital-new-img1.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/hospital-new-img2.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/hospital-new-img3.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>



                    </div>
                  </div>
                </TabPanel>

                <TabPanel>
                  <div className="trusted-content">
                    <div className="trusted-inner-sec">
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo1.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo2.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo3.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo4.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo6.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo7.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo8.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>

                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo5.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo9.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo10.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                      <div className="trusted-logo">
                        <div className="trusted-inner">
                          <img src="/assets/images/institute-brand-logo11.webp" alt="Logo" className="img-responsive" />
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
